import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import MoneyTransferDocumentForm from './forms/MoneyTransferDocumentForm';
import MoneyTransferDocumentList from './lists/MoneyTransferDocumentList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import {SelectButton} from "primereact/selectbutton";
import Button from "../form/Button";
import connect from "react-redux/es/connect/connect";

class MoneyTransferDocumentEditor extends React.Component {

    state = {
        direction: null,
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        if (!this.props.values[this.props.componentConfig.idfield]) {
            let data = {};
            if (this.props.values.moneyrepository === undefined) {
                data.moneyrepository = this.props.till.moneyrepositories.find((moneyrepository) => moneyrepository.component_type === "CashRepository") || null;
            }
            if (Object.keys(data).length) {
                await this.props.setFormValues({...this.props.values, ...data});
            }
        }
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {

        const filter = [];
        const directions = [
            {label: 'Összes', value: null},
            {label: 'Kimenő', value: -1},
            {label: 'Bejövő', value: 1},
        ];
        if (this.state.direction) {
            filter.push({
                field: "direction", value: this.state.direction
            });
        }

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <div className="col-md-12">
                    <div className="row">
                        <List
                            {...this.props}
                            theme="default"
                            header={"Tranzakciók"}
                            actions={<SelectButton value={this.state.direction} options={directions}
                                                   onChange={(e) => this.setState({direction: e.value})}/>}
                            footer={[
                                <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                                    Új
                                </Button>
                            ]}
                        >
                            <MoneyTransferDocumentList moneyrepositoryType="CashRepository" filter={filter} ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                        </List>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="row">
                        <Editor
                            {...this.props}
                            ref={(editor) => this.editor = editor}
                            theme="default"
                            header={"Tranzakció"}
                            footer={[
                                <Button key="0" disabled={ !this.props.dirty || this.props.isLoading || this.props.values.document_id } color="primary" className="pull-right" onClick={ this.saveForm }>
                                    Mentés
                                </Button>
                            ]}
                        >
                            <MoneyTransferDocumentForm {...this.props} />
                        </Editor>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
})(createEditor({componentName: "MoneyTransferDocument", WrappedComponent: MoneyTransferDocumentEditor}));
